/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Speaker_Filters_LabelInputs */



/**
* | output |
* | --- |
* | "Speaker filters" |
*
* @param {Editor_Speaker_Filters_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_speaker_filters_label = /** @type {((inputs?: Editor_Speaker_Filters_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Speaker_Filters_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtres de locuteurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautsprecherfilter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtri per altoparlanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильтры динамиков")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtros de altavoz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("扬声器滤波器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーフィルター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर फ़िल्टर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtros de alto-falante")
	return /** @type {LocalizedString} */ ("Speaker filters")
});